/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxDocumentSenderSourceContactsInner
 */
export interface FaxDocumentSenderSourceContactsInner {
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceContactsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceContactsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceContactsInner
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceContactsInner
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceContactsInner
     */
    title?: string | null;
}

/**
 * Check if a given object implements the FaxDocumentSenderSourceContactsInner interface.
 */
export function instanceOfFaxDocumentSenderSourceContactsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FaxDocumentSenderSourceContactsInnerFromJSON(json: any): FaxDocumentSenderSourceContactsInner {
    return FaxDocumentSenderSourceContactsInnerFromJSONTyped(json, false);
}

export function FaxDocumentSenderSourceContactsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocumentSenderSourceContactsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function FaxDocumentSenderSourceContactsInnerToJSON(value?: FaxDocumentSenderSourceContactsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'phone': value.phone,
        'email': value.email,
        'title': value.title,
    };
}

